import * as Api from "@/utils/request";
export default {
	// 用于显示用户的个人中心
	// 请求方式：get
	// 入参：login_user_id //登录的用户Id
	async center(opt) {
		//console.log(opt);
		let res = await Api.get({
			url: "/v1/user/center",
			params: {
				// login_user_id: 1,
				...opt
			}
		});
		return res;
	},


	// 获取用户的手机号
	// 请求方式：get
	async getUserEncryptionPhone(opt) {
		//console.log(opt);
		let res = await Api.get({
			url: "/v1/user/getUserEncryptionPhone",
			params: {
				...opt
			}
		});
		return res;
	},


	//内容分享接口
	// 请求方式：get
	// 入参：地址 ：'recentBrowse'
	async WeChatShare(url_type) {
		let res = await Api.get({
			url: "/v1/system/getWeChatShare?url_type="+url_type,
		});
		return res;
	},


};
